// src/Pages/ReporteToPdfReactPDF.jsx
import React from "react";
import { useParams, useLocation } from "react-router-dom";
import { PDFDownloadLink } from "@react-pdf/renderer";
import useReporteSnapshot from "../hooks/useReporteSnapshot";
import ReporteDoc from "../components/reportes/ReporteDoc";


function useQuery() {
    const { search } = useLocation();
    return new URLSearchParams(search);
}

export default function ReporteToPdfReactPDF() {
    const { contratoId } = useParams();
    const q = useQuery();
    const auto = q.get("auto") === "1";

    const { loading, error, snapshot } = useReporteSnapshot(contratoId);

    const filename = `reporte-servicio-${contratoId || "sin-id"}.pdf`;

    // --- AUTO, modo silencioso para iframe / parent ---
    if (auto) {
        if (loading || error || !snapshot) {
            return null;
        }

        // Generación auto (sin botón)
        return (
            <PDFDownloadLink
                document={<ReporteDoc data={snapshot} />}
                fileName={filename}
            >
                {({ url }) => {
                    if (url) {
                        // Notifica al padre que está listo
                        window.parent?.postMessage(
                            { type: "PDF_READY", id: contratoId, ok: true, url },
                            "*"
                        );
                    }
                    return null;
                }}
            </PDFDownloadLink>
        );
    }

    // --- Modo manual ---
    return (
        <div style={{ padding: 16 }}>
            {loading && "Cargando datos..."}
            {error && <div style={{ color: "red" }}>{String(error)}</div>}

            {!loading && !error && snapshot && (
                <>
                    <PDFDownloadLink
                        document={<ReporteDoc data={snapshot} />}
                        fileName={filename}
                        style={{
                            display: "inline-block",
                            background: "#1b5e20",
                            color: "#fff",
                            padding: "8px 14px",
                            borderRadius: 8,
                            fontSize: 14,
                            fontWeight: 600,
                            marginBottom: 16,
                            cursor: "pointer",
                            textDecoration: "none",
                        }}
                    >
                        {({ loading }) => (loading ? "Generando PDF..." : "Descargar PDF")}
                    </PDFDownloadLink>
                </>
            )}
        </div>
    );
}
